import { Component, Input } from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { CommonDirectives } from '@app/shared/directives/common-directives';

@Component({
  selector: 'app-load-spinner-wrapper',
  imports: [MatProgressSpinnerModule, CommonDirectives],
  templateUrl: './load-spinner-wrapper.component.html'
})
export class LoadSpinnerWrapperComponent {
  @Input() appearance = 'standard';
  @Input() loading = false;
  @Input() message?: string;
}